module.exports = __webpack_public_path__ + "img/tips-medical.d99fc908.svg";